module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/offerta-min-foto/offerta-min-foto.component.scss
// module id = ./src/app/offerta-min-foto/offerta-min-foto.component.scss
// module chunks = main